import { Options } from '../models';

export interface Configs {
  samelogicApiBaseUrl: string;
}

export const prod: Configs = {
  samelogicApiBaseUrl: 'https://api.samelogic.com'
};

export const dev: Configs = {
  samelogicApiBaseUrl: 'https://localhost:5000'
};

export function getConfig(options: Options): Configs {
  return {
    samelogicApiBaseUrl: options.baseUrl || prod.samelogicApiBaseUrl
  };
}
